import React from 'react';
import UserIcon from 'components/v2/icons/UserIcon';
import VerticalNav from 'components/v2/navs/VerticalNav';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import PropTypes from 'prop-types';

const Sidebar = ({ activePage }) => {
  const profileActive = activePage === 'profile';
  const { t } = useTranslation();
  return (
    <VerticalNav>
      <VerticalNav.NavItemWithIcon
        url="/warehouse/user/profile"
        active={profileActive}
        title={titleize(t('PROFILE', { count: 1 }))}
      >
        {(iconClassName) => (
          <UserIcon size='"medium' className={iconClassName} />
        )}
      </VerticalNav.NavItemWithIcon>
    </VerticalNav>
  );
};

Sidebar.propTypes = {
  activePage: PropTypes.string,
};

Sidebar.defaultProps = {
  activePage: 'profile',
};

export default Sidebar;
